export default __webpack_public_path__ + "static/three-37ec8b384884a4b6905c482dfdb96848.jpg";